import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";

export const AdvanceTableContext = createContext(null);

const AdvanceTableProvider = ({ children, ...rest }) => {
  const value = useMemo(() => rest, [rest]);

  return (
    <AdvanceTableContext.Provider value={value}>
      {children}
    </AdvanceTableContext.Provider>
  );
};

AdvanceTableProvider.propTypes = { children: PropTypes.node };

export const useAdvanceTableContext = () => {
  const ctx = useContext(AdvanceTableContext);
  if (!ctx) {
    throw new Error("AdvanceTable must be used inside AdvanceTableProvider");
  }
  return ctx;
};

export default AdvanceTableProvider;
